// React
import React, { useState } from "react";

// Helper Imports
import { formatDate } from "../../../../../Helpers/formatters";

// MUI Imports
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";
import MuiTooltip from '@mui/material/Tooltip';

import EditModal from "../../../../../Components/EditModal";

const MemberEventsBody = ({ userEvents, page, rowsPerPage, }) => {
  const [open, setIsOpen] = useState(false);
  const [loadedContent, setLoadedContent] = useState(null);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <EditModal
        open={open}
        handleClose={handleClose}
        customCSS={{ overflow: "scroll" }}
      >
        <div className="modal-header">
          <h2 style={{ padding: ".5rem", color: "#fff" }}>Metadata</h2>
          <CloseIcon className="close-icons" onClick={() => setIsOpen(false)} />
        </div>
        {open && loadedContent}
      </EditModal>
      <TableBody>
        {userEvents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
          const {timestamp, eventCategory, eventAction, ipAddress, userAgent, metadata} = row;
          return (
            <TableRow key={index}>
              <TableCell className="tableCell" align="center">
                {formatDate(timestamp)}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {eventCategory}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {eventAction}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {ipAddress}
              </TableCell>
              <MuiTooltip title={userAgent} placement="top">
                <TableCell className="tableCell" align="center">
                  {userAgent
                    ? userAgent.slice(0, 40) + "..."
                    : "Nothing to show"}
                </TableCell>
              </MuiTooltip> 
              <TableCell className="tableCell" align="center">
                {metadata ? (
                  <button
                    onClick={() => {
                      setIsOpen(true);
                      setLoadedContent(metadata);
                    }}
                    className="view-meta-btn"
                  >
                    <span>View Metadata</span>
                  </button>
                ) : (
                  <p>No metadata</p>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
};

export default MemberEventsBody;
